import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const isNgrok = BASE_URL && (BASE_URL.includes("ngrok-free.app") || BASE_URL.includes("ngrok-free.dev") || BASE_URL.includes("ngrok.io"));

/**
 * Public axios instance for unauthenticated endpoints (e.g. flights search).
 * Does not send cookies (withCredentials: false).
 */
const axiosPublic = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    ...(isNgrok ? { "ngrok-skip-browser-warning": "true" } : {}),
  },
  withCredentials: false,
});

export default axiosPublic;
